import { useState, useEffect } from 'react';
import { format, addMinutes } from 'date-fns';
import { themes, icons } from '../assets';

export const GetColor = (filtro, type) => {
  if (!filtro) return 'hotpink';
  switch (filtro.toLowerCase()) {
    case 'alarme/erro':
      return type === 'ranges' ? themes.statusE : themes.red;
    case 'e':
      return type === 'ranges' ? themes.statusE : themes.red;
    case 'atenção':
      return type === 'ranges' ? themes.statusW : themes.yellow;
    case 'atencao':
      return type === 'ranges' ? themes.statusW : themes.yellow;
    case 'w':
      return type === 'ranges' ? themes.statusW : themes.statusW;
    case 'rodando':
      return type === 'ranges' ? themes.statusN : themes.green;
    case 'normal':
      return type === 'ranges' ? themes.statusN : themes.green;
    case 'n':
      return type === 'ranges' ? themes.statusN : themes.green;
    case 'o':
      return type === 'ranges' ? themes.statusN : themes.green;
    case 'desconectada':
      return themes.darkgray;
    case 'desligada':
      return themes.label;
    case 'off':
      return themes.label;
    case 'sem dados':
      return themes.darkgray;
    case 'alarme/bloqueio/atenção':
      return type === 'ranges' ? themes.statusE : themes.red;
    case 'alarme/bloqueio':
      return type === 'ranges' ? themes.statusE : themes.red;
    default:
      return 'hotpink';
  }
};

export const usePersistedState = (key, initialState) => {
  const [state, setState] = useState(() => {
    const storageValue = localStorage.getItem(key);

    if (storageValue) return JSON.parse(storageValue);
    return initialState;
  });

  useEffect(() => {
    localStorage.setItem(key, JSON.stringify(state));
  }, [key, state]);

  return [state, setState];
};

export const formatDate = (originalDate) => {
  const split = originalDate.split('T');
  const hour = split[1].slice(0, 5);
  return { date: split[0], hour };
};

export function justNumbers(string) {
  string = string.replace(/\D/g, '');
  return string;
}

export function justNumbersObject(string, stringOld, type) {
  var traco = string.target.value.split("-")
  var ponto = string.target.value.split(".")
  var letras = string.target.value.split("")
  switch (type) {
    case "latitude":
      if(
        (string.target.value.replace(/\D/g, '').length <= 8)
        && (string.target.value.replace(/[\u0020-\u002D]|[\u002F-\uDFFF]/g, '').length <= 1)
        && (string.target.value.replace(/[\u0020-\u002C]|[\u002E-\uDFFF]/g, '').length <= 1)
        && (ponto[0].replace(/\D/g, '').length <= 2)
        && (ponto[0].replace(/\D/g, '').length >= 0)
        && (ponto[1] ? ponto[1].replace(/\D/g, '').length <= 6 : true)
        && (string.target.value.replace(/[\u0020-\u002C]|[\u002E-\uDFFF]/g, '').length !== 1  ? traco[0] <= 90 : traco[1] <= 90)
        && (traco.length !== 2 || letras[0] === "-")
        ){
          string.target.value = string.target.value.replace(/[\u0020-\u002C]|[\u002F]|[\u003A-\u04FF]|[\uD800-\uDBFF][\uDC00-\uDFFF]/g, '')
      } else string.target.value = stringOld
      return string;
    case "longitude":
      if(
        (string.target.value.replace(/\D/g, '').length <= 9)
        && (string.target.value.replace(/[\u0020-\u002D]|[\u002F-\uDFFF]/g, '').length <= 1)
        && (string.target.value.replace(/[\u0020-\u002C]|[\u002E-\uDFFF]/g, '').length <= 1)
        && (ponto[0].replace(/\D/g, '').length <= 3)
        && (ponto[0].replace(/\D/g, '').length >= 0)
        && (ponto[1] ? ponto[1].replace(/\D/g, '').length <= 6 : true)
        && (string.target.value.replace(/[\u0020-\u002C]|[\u002E-\uDFFF]/g, '').length !== 1  ? traco[0] <= 180 : traco[1] <= 180)
        && (traco.length !== 2 || letras[0] === "-")
        ){
          string.target.value = string.target.value.replace(/[\u0020-\u002C]|[\u002F]|[\u003A-\u04FF]|[\uD800-\uDBFF][\uDC00-\uDFFF]/g, '')
      } else string.target.value = stringOld
      return string;
  }
}

export function removeInvalidChars(string) {
  string.target.value = string.target.value.replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, '');
  return string
}

export const newFormatDateReports = (timestamp) => {
  // addMinutes(formatedDate, formatedDate.getTimezoneOffset()),'dd-LL-yyyy_00_00'
  const formatedDate = new Date(timestamp);
  return format(addMinutes(formatedDate, 0), 'dd-LL-yyyy_HH_mm');
};

export const newFormatDateButton = (timestamp) => {
  // addMinutes(formatedDate, formatedDate.getTimezoneOffset()),'dd-LL-yyyy_00_00'
  const formatedDate = new Date(timestamp);
  return format(addMinutes(formatedDate, 0), 'dd/LL/yyyy');
};

export const newFormatDate = (timestamp, type) => {
  const numericTimestamp = Number(timestamp);
  const formatedDate =
    timestamp instanceof Date
      ? timestamp
      : new Date(
          Number.isFinite(numericTimestamp) && Math.abs(numericTimestamp) < 1e12
            ? numericTimestamp * 1000
            : numericTimestamp
        );

  if (Number.isNaN(formatedDate.getTime())) return '';

  if (type === 'hours')
    return format(formatedDate, 'HH:mm');
  if (type === 'day')
    return format(formatedDate, 'd/L');
  return format(formatedDate, 'd/L/y - HH:mm');
};


// === Status canônicos do park/equipamento ===
//
// Modelo: status PRIMARIO (4 valores) + flag de atencao ortogonal.
// Substitui (incrementalmente) o getStatus() legado que concatenava
// label string como "rodando/atenção" — consumidores faziam
// .includes('atenção') / .includes('alarme'), o que era frágil
// (typo, acento, espaço, ordem).
//
// Uso novo recomendado:
//   const info = getStatusInfo(park.statusMap.status, park.statusMap.isRangeWarning);
//   if (info.primary === STATUS_PRIMARY.ALARME) { ... }
//   if (info.hasAttention) { ... }
//   const color = getStatusColor(info);
//   const icon = getStatusIcon(info);
//
// getStatus() continua existindo (backward compat) e agora delega
// internamente pra getStatusInfo.
export const STATUS_PRIMARY = Object.freeze({
  ALARME: 'alarme',
  RODANDO: 'rodando',
  DESLIGADA: 'desligada',
  SEM_DADOS: 'sem-dados',
});

// Chave do cache de historico (state.historic). Antes era so o ihmname
// da variavel — mas variaveis com o MESMO ihmname em maquinas diferentes
// (ex.: 'Vazao' em todas as bombas) colidiam: ao trocar de maquina o
// grafico lia o cache da anterior. Agora compomos thingId + variavel pra
// isolar por maquina. Fallback so-variavel quando thingId ausente (back
// compat defensivo — todos os dispatchers passam thingId).
export const historicKey = (thingId, variable) =>
  thingId !== undefined && thingId !== null
    ? `${thingId}::${variable}`
    : `${variable}`;

const ATTENTION_SOURCES = new Set([
  'W', // contador atencao na AlertDTO
  // valores literais de strings que historicamente representavam
  // atencao pura (sem status primario claro)
]);

export const getStatusInfo = (status, isWarning) => {
  let primary = STATUS_PRIMARY.SEM_DADOS;
  let hasAttention = !!isWarning;

  if (status && typeof status === 'object') {
    const { W, N, O, E, OFF, NotConnected } = status;
    if (NotConnected) primary = STATUS_PRIMARY.SEM_DADOS;
    else if (E) primary = STATUS_PRIMARY.ALARME;
    else if (W) {
      // W na AlertDTO historicamente significou 'em atencao' sem
      // primario claro — tratamos como rodando+atencao (matche o
      // que o legacy getStatus retornava: 'atenção').
      primary = STATUS_PRIMARY.RODANDO;
      hasAttention = true;
    } else if (N || O) primary = STATUS_PRIMARY.RODANDO;
    else if (OFF) primary = STATUS_PRIMARY.DESLIGADA;
  } else if (typeof status === 'string') {
    const u = status.toUpperCase();

    // Strings que tem '/atenção' embutido (output do getStatus legacy:
    // 'rodando/atenção', 'alarme/bloqueio/atenção', 'desligada/atenção',
    // 'sem dados/atenção'). Marca hasAttention e remove o sufixo pra
    // extrair o primary do resto. Tolera variantes com/sem acento.
    let core = u;
    if (u.includes('ATENÇÃO') || u.includes('ATENCAO')) {
      hasAttention = true;
      core = u.replace('/ATENÇÃO', '').replace('/ATENCAO', '').trim();
      if (!core || core === 'ATENÇÃO' || core === 'ATENCAO') {
        // 'atenção' standalone — semanticamente: rodando + atencao
        primary = STATUS_PRIMARY.RODANDO;
        return { primary, hasAttention };
      }
    }

    // Match no core (sem sufixo de atencao)
    if (
      core === 'BLOQUEADO' ||
      core === 'ALARME' ||
      core === 'ALARME/BLOQUEIO' ||
      core === 'E'
    ) {
      primary = STATUS_PRIMARY.ALARME;
    } else if (
      core === 'RODANDO' ||
      core === 'OPERANDO' ||
      core === 'O' ||
      core === 'N' ||
      core === 'NORMAL'
    ) {
      primary = STATUS_PRIMARY.RODANDO;
    } else if (
      core === 'PARADO' ||
      core === 'DESLIGADO' ||
      core === 'DESLIGADA' ||
      core === 'OFF'
    ) {
      primary = STATUS_PRIMARY.DESLIGADA;
    } else if (
      core === 'SEMDADOS' ||
      core === 'SEM DADOS' ||
      core === 'NOTCONNECTED'
    ) {
      primary = STATUS_PRIMARY.SEM_DADOS;
    } else if (ATTENTION_SOURCES.has(core)) {
      primary = STATUS_PRIMARY.RODANDO;
      hasAttention = true;
    }
  }

  return { primary, hasAttention };
};

// Helpers semanticos pra consumir o struct sem string-match.
export const isAlarmStatus = (info) =>
  !!info && info.primary === STATUS_PRIMARY.ALARME;
export const isOperatingStatus = (info) =>
  !!info && info.primary === STATUS_PRIMARY.RODANDO;
export const isOffStatus = (info) =>
  !!info && info.primary === STATUS_PRIMARY.DESLIGADA;
export const isNoDataStatus = (info) =>
  !!info && info.primary === STATUS_PRIMARY.SEM_DADOS;
export const hasAttention = (info) => !!info && info.hasAttention === true;

// Normaliza o tipo cru de um equipamento (thing/appliance) numa categoria
// canonica: 'ucha' (turbogerador / geracao de energia) ou 'eba' (bomba /
// consumo de potencia). Retorna null quando nao reconhece.
//
// POR QUE: o cadastro tem valores INCONSISTENTES entre telas antigas e
// novas — a mesma familia aparece como 'tga' ou 'ucha', e 'bomba' ou
// 'eba'. Quem comparava so '=== tga'/'=== bomba' (ex.: saga de 1o nivel)
// DESCARTAVA silenciosamente as maquinas com o outro rotulo, sumindo do
// somatorio (geracao/potencia batia errado) e, num parque misto, deixando
// so o tipo que casava. Classificar num unico lugar, case-insensitive e
// com sinonimos, elimina esse buraco. Aceita string ou objeto {type|name}.
export const classifyEquipmentType = (rawType) => {
  let t = rawType;
  if (t && typeof t === 'object') t = t.type || t.name;
  if (!t) return null;
  t = String(t).toLowerCase();
  if (t === 'ucha' || t === 'tga' || t.includes('ucha') || t.includes('tga')) {
    return 'ucha';
  }
  // bluebox e um dispositivo de monitoramento de BOMBA (thing type sempre
  // associada a uma EBA) — conta como consumo/eba nas somas e rankings.
  if (
    t === 'bomba' ||
    t === 'eba' ||
    t === 'bluebox' ||
    t.includes('bomba') ||
    t.includes('eba') ||
    t.includes('bluebox')
  ) {
    return 'eba';
  }
  return null;
};

// getStatus legado: retorna string concatenada como antes. Mantido
// pra nao quebrar consumidores que ainda usam string-match. Novos
// consumidores devem usar getStatusInfo direto.
export const getStatus = (status, isWarning) => {
  const info = getStatusInfo(status, isWarning);
  let base;
  switch (info.primary) {
    case STATUS_PRIMARY.ALARME:
      base = 'alarme/bloqueio';
      break;
    case STATUS_PRIMARY.RODANDO:
      base = 'rodando';
      break;
    case STATUS_PRIMARY.DESLIGADA:
      base = 'desligada';
      break;
    case STATUS_PRIMARY.SEM_DADOS:
    default:
      base = 'sem dados';
  }
  return info.hasAttention ? `${base}/atenção` : base;
};

// Cor do status baseada no struct. Substitui GetColor(label) pra
// consumidores migrados — sem string-match, sem normalizacao de
// acentos. type === 'ranges' usa palette alternativa themes.statusX.
export const getStatusColor = (info, type) => {
  if (!info) return 'hotpink';
  switch (info.primary) {
    case STATUS_PRIMARY.ALARME:
      return type === 'ranges' ? themes.statusE : themes.red;
    case STATUS_PRIMARY.DESLIGADA:
      return themes.label;
    case STATUS_PRIMARY.SEM_DADOS:
      return themes.darkgray;
    case STATUS_PRIMARY.RODANDO:
      if (info.hasAttention) {
        return type === 'ranges' ? themes.statusW : themes.yellow;
      }
      return type === 'ranges' ? themes.statusN : themes.green;
    default:
      return 'hotpink';
  }
};

// Icone do mapa baseado no struct. Combina primary+hasAttention pra
// escolher entre as 8 variantes (4 status x com/sem atencao).
export const getStatusIcon = (info) => {
  if (!info) return icons.SemDados;
  switch (info.primary) {
    case STATUS_PRIMARY.ALARME:
      return info.hasAttention ? icons.ErrorAlarmeIcon : icons.MapIcon;
    case STATUS_PRIMARY.RODANDO:
      return info.hasAttention ? icons.FuncionandoAlarme : icons.Funcionando;
    case STATUS_PRIMARY.DESLIGADA:
      return info.hasAttention ? icons.DesligadaAlarmeIcon : icons.Desligada;
    case STATUS_PRIMARY.SEM_DADOS:
      return info.hasAttention ? icons.SemDadosAlarmeIcon : icons.SemDados;
    default:
      return icons.SemDados;
  }
};

export const statusList = [
  { label: 'Alarme/erro', color: themes.red },
  { label: 'Atenção', color: themes.yellow },
  { label: 'Rodando', color: themes.lightgreen },
  { label: 'Desligada', color: themes.label },
  { label: 'Sem Dados', color: themes.darkgray },
];

export const getMapIcon = (filtro) => {
  if (!filtro) return '';
  switch (filtro.toLowerCase()) {
    case 'alarme/bloqueio/atenção':
      return icons.ErrorAlarmeIcon;
    case 'alarme/bloqueio':
      return icons.MapIcon;
    case 'rodando/atenção':
      return icons.FuncionandoAlarme;
    case 'rodando':
      return icons.Funcionando;
    case 'desligada/atenção':
      return icons.DesligadaAlarmeIcon;
    case 'desligada':
      return icons.Desligada;
    case 'sem dados/atenção':
      return icons.SemDadosAlarmeIcon;
    case 'sem dados':
      return icons.SemDados;
    default:
      return icons.SemDados;
  }
};

export const formatValue = (value) => {
  if (typeof value === 'string') {
    const format = parseFloat(value);
    return format.toLocaleString({
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      style: 'decimal',
    });
  }
  if (typeof value === 'number') {
    return value.toLocaleString('pt-br', {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
      style: 'decimal',
    });
  }
  return value;
};

// Auto-escalonamento de unidades. Ao inves de mostrar "4.084.955,47 kWh"
// pro operador, mostramos "4,08 GWh". A cada potencia de 1000 sobe pra
// proxima unidade. Aceita numero (em baseUnit) ou string. Se a string ja
// vier com unidade embutida (ex.: backend retornando "13,57 MWh"),
// devolve como esta — assume que o backend ja escolheu a unidade.
const ENERGY_UNITS = ['Wh', 'kWh', 'MWh', 'GWh', 'TWh'];
const POWER_UNITS = ['W', 'kW', 'MW', 'GW'];
const FLOW_UNITS = ['l/s', 'm³/s']; // pra usos futuros — 1000 l/s = 1 m³/s

const HAS_UNIT_RE = /[a-zA-Z]/;

const autoScale = (units, value, baseUnit) => {
  if (value === null || value === undefined) return '-';
  if (typeof value === 'string') {
    if (HAS_UNIT_RE.test(value)) return value;
    const parsed = parseFloat(value.replace(',', '.'));
    if (!Number.isFinite(parsed)) return value;
    return autoScale(units, parsed, baseUnit);
  }
  if (typeof value !== 'number' || !Number.isFinite(value)) return '-';
  const startIdx = units.indexOf(baseUnit);
  if (startIdx === -1) return `${formatValue(value)} ${baseUnit}`;
  let scaled = value;
  let idx = startIdx;
  while (Math.abs(scaled) >= 1000 && idx < units.length - 1) {
    scaled /= 1000;
    idx += 1;
  }
  return `${formatValue(scaled)} ${units[idx]}`;
};

export const formatEnergyAutoUnit = (value, baseUnit = 'kWh') =>
  autoScale(ENERGY_UNITS, value, baseUnit);

export const formatPowerAutoUnit = (value, baseUnit = 'kW') =>
  autoScale(POWER_UNITS, value, baseUnit);

export const formatFlowAutoUnit = (value, baseUnit = 'l/s') =>
  autoScale(FLOW_UNITS, value, baseUnit);

export {
  notifyError,
  notifySuccess,
  notifyWarning,
  notifyInfo,
} from './notify';

export { isAbortError } from './request.utils';
export { useAbortSignal } from './use-abort-signal';
export { createReconnectingSubscription } from './reconnecting-subscription';
export {
  sessionCache,
  invalidateSessionCache,
  clearSessionCache,
} from './session-cache';
export { useDebounce } from './use-debounce';
export {
  calcChartStats,
  formatDuration,
  computeCorrelation,
  classifyCorrelation,
  detectChangePoints,
  detectOperationalSegments,
} from './chart-stats';
export { exportChartToCSV, exportChartToPNG } from './chart-export';
export { downsampleLTTB } from './downsample';
export {
  loadAnnotations,
  saveAnnotations,
  addAnnotation,
  removeAnnotation,
} from './annotations';

export { cognitoErrorMessage } from './cognito-errors';
export { getRecentMachines, pushRecentMachine } from './recent-machines';
export { useAuth } from './use-auth';
export {
  APP_VERSION,
  APP_COMMIT_SHA,
  APP_BUILD_AT,
  APP_BUILD_DATE,
  APP_BRANCH,
  APP_VERSION_LABEL,
} from './version';
export { useVersionPoll } from './use-version-poll';
export { useBackendVersion } from './use-backend-version';
export { initSentry, captureException, captureMessage } from './sentry';


